module.exports = __webpack_public_path__ + "static/media/AppStore_QRCode.6dd152d8.svg";